import lightbox from 'lightbox2';

lightbox.option({
  fadeDuration: 400,
  imageFadeDuration: 400,
  resizeDuration: 500,
  albumLabel: 'Bilde %1 av %2',
});
